export const required = (message = 'nayen.validation.required') =>
    (value, allValues, props) => value ? undefined : props.translate(message);

export default required;